export default "__VITE_ASSET__0f537a79__"